import { Avatar, Button, LinkButton, Text } from '@sketch/components'
import {
  IndexLayoutContent as BaseIndexLayoutContent,
  IndexLayoutOldSubtitle,
  IndexLayoutOldTitle,
} from '@sketch/modules-common'
import styled from 'styled-components'

export const IndexLayoutContent = styled(BaseIndexLayoutContent)`
  max-width: 380px;
  margin: auto;

  ${IndexLayoutOldTitle} {
    /* Allow very big names, to wrap more gracefully */
    max-width: 600px;
    overflow-wrap: break-word;
  }

  ${IndexLayoutOldSubtitle} {
    color: ${({ theme }) => theme.colors.foreground.secondary.C};
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  padding: 32px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  border-radius: ${({ theme }) => theme.radii.large};

  box-shadow: ${({ theme }) => theme.shadows.boxShadow.panel};
`

export const UserName = styled.span`
  color: ${({ theme }) => theme.colors.sketch.A};
`

export const UserAvatar = styled(Avatar)`
  margin-bottom: 14px; /* stylelint-disable-line scales/space */
`

export const ContinueButton = styled(LinkButton)`
  margin-top: 16px;
`

export const SwitchAccount = styled(Button)`
  && {
    margin-top: 16px;
    margin-left: 0;
  }
`

export const SignOutWrapper = styled.span`
  margin-top: 20px;
`

export const InnerUserName = styled(Text)`
  /* Allow very big names, to wrap more gracefully */
  overflow-wrap: anywhere;
`

export const InnerUserEmail = styled(Text)`
  /* Allow very big email, to wrap more gracefully */
  overflow-wrap: anywhere;
`
